import { JsonObject } from "ta-json";

import { MapStringTo } from "../base-types";
import Link from "../link";
import { RelationResource } from "./relation-resource";

@JsonObject()
export class RelationMapResource implements MapStringTo<RelationResource | Link> {
    [key: string]: RelationResource | Link;
}
